<template>
  <section
    class="viewsrhqyClockManage_VehicleReportDetail h-full overflow-y-auto overflow-x-hidden space-y-4 p-4"
  >
    <viewTitle
      :title="
        `业务管理 / 发货打卡管理 / 车辆报备管理 / ${
          isNew ? '添加报备车辆' : '查看报备车辆'
        }`
      "
      :showReturn="true"
    />
    <el-form class="detail_form" ref="form" :model="form" label-width="100px" :rules="rules">
      <el-form-item label="报备类型" prop="type">
        <el-radio-group v-model="form.type" v-if="isNew" @change="form.add_reason = undefined">
          <el-radio :label="1">白名单</el-radio>
          <el-radio :label="2">未打卡预约车辆</el-radio>
        </el-radio-group>
        <span class="text-gray-500" v-else>{{
          form.type == 1 ? "白名单" : "未打卡预约车辆"
        }}</span>
      </el-form-item>
      <el-form-item label="基地" prop="company_name">
        <span class="text-gray-500">{{ form.company_name || baseInfo.com_name || '--' }}</span>
      </el-form-item>
      <el-form-item label="供应商" prop="supplier_id">
        <tableSelector
          title="选择供应商"
          :multiple="false"
          v-model="form.supplier_id"
          :rows.sync="form.supplier"
          @change="onSupplierChange"
          :columns="supplierColumns"
          :params="supplier_params"
          :clearable="isNew"
          :http-request="data => unitLoad(data, 'supplier')"
        >
          <div class="mb-4" slot="search">
            <el-input clearable class="w-60" v-model="supplier_params.keyword" placeholder="搜索账号、手机号和联系人"></el-input>
          </div>
          <div slot="content">
            <span class="text-gray-500" v-if="form.supplier.length > 0">{{
              form.supplier | formatUnit
            }}</span>
          </div>
          <el-link
            type="primary"
            class="align-top"
            v-if="isNew"
            :underline="false"
            >请选择供应商</el-link
          >
        </tableSelector>
      </el-form-item>
      <el-form-item label="木片厂" prop="chip_id" v-if="form.supplier_id">
        <tableSelector
          title="选择木片厂"
          :multiple="false"
          v-model="form.chip_id"
          :rows.sync="form.chip"
          :columns="chipColumns"
          :params="chip_params"
          :clearable="isNew"
          :http-request="data => unitLoad({ ...data, supplier_id: form.supplier_id }, 'chip')"
        >
          <div class="mb-4" slot="search">
            <el-input clearable class="w-60" v-model="chip_params.keyword" placeholder="搜索账号、手机号和联系人"></el-input>
          </div>
          <div slot="content">
            <span class="text-gray-500" v-if="form.chip.length > 0">{{
              form.chip | formatUnit
            }}</span>
          </div>
          <el-link
            type="primary"
            v-if="isNew"
            class="align-top"
            :underline="false"
            >请选择木片厂</el-link
          >
        </tableSelector>
      </el-form-item>
      <el-form-item label="车牌类型" prop="license_plate_type">
        <el-radio-group v-model="form.license_plate_type" v-if="isNew">
          <el-radio :label="1">蓝色</el-radio>
          <el-radio :label="2">黄色</el-radio>
          <el-radio :label="3">黄绿</el-radio>
        </el-radio-group>
        <span class="text-gray-500" v-else>
          {{
            form.license_plate_type == 1
              ? "蓝色"
              : form.license_plate_type == 2
              ? "黄色"
              : "黄绿"
          }}
        </span>
      </el-form-item>
      <el-form-item label="添加车牌" prop="license_plate">
        <template v-if="isNew">
          <el-input
            class="w-96"
            v-model.trim="form.license_plate"
            placeholder="请输入车牌"
          >
          </el-input>
          <el-button
            v-show="form.license_plate"
            class="ml-2"
            size="mini"
            type="primary"
            v-has="['c-clock-report-track']"
            @click="onCarTrack"
            >查看历史北斗返回情况</el-button
          >
        </template>
        <span class="text-gray-500" v-else>{{ form.license_plate }}</span>
      </el-form-item>
      <el-form-item label="添加原因" prop="add_reason">
        <el-select
          v-if="isNew"
          placeholder="请选择原因"
          class="w-96"
          v-model="form.add_reason"
        >
          <el-option
            v-for="text in reason[form.type]"
            :key="text"
            :label="text"
            :value="text"
          />
        </el-select>
        <span class="text-gray-500" v-else>{{ form.add_reason }}</span>
      </el-form-item>
      <el-form-item label="相关附件" prop="files">
        <c-file-upload
          class="w-96"
          :isShowTip="false"
          :showUpload="isNew"
          v-model="form['files']"
        ></c-file-upload>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          type="textarea"
          :rows="2"
          v-if="isNew"
          class="w-96"
          placeholder="请输入内容"
          v-model="form.remark"
        >
        </el-input>
        <span class="text-gray-500" v-else>{{ form.remark || "--" }}</span>
      </el-form-item>
      <el-form-item label="审批备注" v-if="form.approval_remark">
        <span class="text-gray-500">{{ form.approval_remark }}</span>
      </el-form-item>
      <el-form-item label="提交人" v-if="form.submitter_name">
        <span class="text-gray-500">{{ form.submitter_name }}</span>
      </el-form-item>
      <el-form-item label="提交时间" v-if="form.submit_time">
        <span class="text-gray-500">{{ form.submit_time|timeFormat }}</span>
      </el-form-item>
      <el-form-item label="审批人" v-if="form.approver_name">
        <span class="text-gray-500">{{ form.approver_name }}</span>
      </el-form-item>
      <el-form-item label="审批时间" v-if="form.approval_time">
        <span class="text-gray-500">{{ form.approval_time|timeFormat }}</span>
      </el-form-item>
      <el-form-item label="关闭原因" v-if="form.close_reason">
        <span class="text-gray-500">{{ form.close_reason }}</span>
      </el-form-item>
    </el-form>
    <div style="height: 56px;"></div>
    <div
      class="absolute bottom-0 left-0 space-x-4 bg-white w-full px-4 py-2 box-border z-50 border-t border-solid border-gray-200"
      v-if="$route.params.id == 0"
    >
      <el-button @click="onSave" size="medium" class="w-20" type="primary"
        >保 存</el-button
      >
    </div>
    <GPSDetail ref="GPSDetail" />
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import GPSDetail from "./GPSDetail.vue";
import tableSelector from "@/components/tableSelector/index.vue";
import moment from "moment";
export default {
  data() {
    return {
      supplier_params: {
        keyword: ""
      },
      chip_params: {
        keyword: ""
      },
      form: {
        type: 1,
        license_plate_type: 1,
        supplier: [],
        chip: [],
        supplier_id: "",
        chip_id: "",
        license_plate: "",
        add_reason: "",
        files: [],
        remark: ""
      },
      rules: {
        type: [
          { required: true, message: "请选择报备类型", trigger: "change" }
        ],
        supplier_id: [
          { required: true, message: "请选择供应商", trigger: "change" }
        ],
        chip_id: [
          { required: true, message: "请选择木片厂", trigger: "change" }
        ],
        license_plate_type: [
          { required: true, message: "请选择车牌类型", trigger: "change" }
        ],
        license_plate: [
          { required: true, message: "请输入车牌", trigger: "blur" },
          { message: "车牌号格式错误", trigger: "blur", pattern: /^.{7,8}$/ }
        ],
        add_reason: [
          { required: true, message: "请选择原因", trigger: "change" }
        ],
        files: [
          {
            required: true,
            message: "请上传相关附件",
            trigger: "change",
            type: "array"
          }
        ]
      },
      reason: {
        1: ["设备损坏","检测违规","设备掉线","未入网"],
        2: ["忘记打卡","打错卡","其他备注"]
      },
      supplierColumns: [
        { label: "供应商名称", prop: "full_name" },
        { label: "供应商编号", prop: "unit_code" }
      ],
      chipColumns: [
        { label: "木片厂名称", prop: "full_name" },
        { label: "账号", prop: "account" }
      ]
    };
  },

  computed: {
    ...mapGetters(["baseInfo", "baseRole"]),
    isNew() {
      return this.$route.params.id == 0;
    }
  },

  watch: {},

  components: {
    tableSelector,
    GPSDetail
  },

  mixins: [],

  beforeCreate() {},

  created() {
    this.getDetail();
  },

  beforeMount() {},

  mounted() {},

  activated() {},

  deactivated() {},

  filters: {
    formatUnit(list, key = "full_name") {
      return list.map(e => e[key]).join("；");
    },
    timeFormat(value, style = 'YYYY-MM-DD HH:mm:ss') {
      return value ? moment.unix(value).format(style) : '--'
    }
  },

  methods: {
    onSupplierChange() {
      this.form.chip_id = "";
      this.form.chip = [];
    },
    getDetail() {
      if (this.$route.params.id != 0) {
        this.$common
          .http({
            url: "/api/queue/admin/detail_car_report",
            data: {
              id: this.$route.params.id
            }
          })
          .then(res => {
            const {
              chip_id,
              supplier_id,
              chip_name,
              supplier_name,
              ...params
            } = res.data.data;
            this.form = {
              ...params,
              chip_id: [chip_id],
              supplier_id: [supplier_id],
              chip: [{ full_name: chip_name, id: chip_id }],
              supplier: [{ full_name: supplier_name, id: supplier_id }]
            };
          });
      }
    },
    async unitLoad(params, code) {
      const role = this.baseRole.find(e => e.code === code);
      const dataObj = await this.$common.http({
        url: "/api/queue/admin/query_unit",
        data: {
          ...params,
          // 关键步骤：供应商弹窗按角色 code 查询，后端会展开为当前基地下全部同 code 角色。
          role_codes: [role.code],
          state: "1"
        }
      });
      return {
        data: dataObj.data.data.data,
        total: dataObj.data.data.total
      };
    },
    onSave() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          const { supplier, chip, ...params } = this.form;
          await this.$common.http({
            url: "/api/queue/admin/create_car_report",
            data: {
              ...params,
              supplier_id: String(params.supplier_id),
              chip_id: String(params.chip_id)
            }
          });
          this.$router.back();
        }
      });
    },
    // 查看北斗
    async onCarTrack() {
      this.$refs.GPSDetail.onOpen({
        license_plate: this.form.license_plate,
        license_plate_type: this.form.license_plate_type
      });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-input__validateIcon {
  display: none;
}
</style>
